import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="bg-accent">
      <footer
        style={{
          background: `url(${"https://i.ibb.co/FWPHftQ/mbaba-footer.png"})`,
          backgroundSize: "cover",
        }}
        className="p-10 mt-2"
      >
        <div className="text-center footer text-white flex justify-around max-w-7xl mx-auto px-1">
          <div>
            <span className="footer-title opacity-100">Services</span>
            <Link className="hover:text-primary">Branding</Link>
            <Link className="hover:text-primary">Design</Link>
            <Link className="hover:text-primary">Marketing</Link>
            <Link className="hover:text-primary">Advertisement</Link>
          </div>
          <div>
            <span className="footer-title opacity-100">Company</span>
            <Link className="hover:text-primary">About us</Link>
            <Link className="hover:text-primary">Contact</Link>
            <Link className="hover:text-primary">Jobs</Link>
            <Link className="hover:text-primary">Press kit</Link>
          </div>
          <div>
            <h2 className="footer-title opacity-100">Legal</h2>
            <Link className="hover:text-primary">Terms of use</Link>
            <Link className="hover:text-primary">Privacy policy</Link>
            <Link className="hover:text-primary">Cookie policy</Link>
            <Link className="hover:text-primary">Condition</Link>
          </div>
        </div>
        <div className="text-gray-200 text-center text-3xl">
          <Link
            className="text-decoration-none text-white"
            to="https://www.facebook.com/mbaba23/"
          >
            <FontAwesomeIcon
              icon={faFacebook}
              className="p-5 text-white hover:text-primary hover:scale-110 duration-500"
            />
          </Link>
          <Link
            className="text-decoration-none text-white"
            to="https://api.whatsapp.com/send?phone=1754675993"
          >
            <FontAwesomeIcon
              icon={faWhatsapp}
              className="p-5 text-white hover:text-primary hover:scale-110 duration-500"
            />
          </Link>
          <Link
            className="text-decoration-none text-white"
            to="https://www.youtube.com/channel/UCmCl_q--DW7q7GS7aJ3RLQQ"
          >
            <FontAwesomeIcon
              icon={faYoutube}
              className="p-5 text-white hover:text-primary hover:scale-110 duration-500"
            />
          </Link>
        </div>
        <div className="mb-5 text-center text-white">
          <p>
            Copyright © {new Date().getFullYear()} - All right reserved By Mbaba
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
